function selection_cloneShallow() {
  var clone = this.cloneNode(false), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

function selection_cloneDeep() {
  var clone = this.cloneNode(true), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

export default function(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/selection/clone.js
// module id = 668
// module chunks = 0